module.exports = __webpack_public_path__ + "img/v_1.acfb177c.png";